import Group from "./selector";
import withPackingGroup from "./withPackingGroup";

export default withPackingGroup(Group);
